import { WebHIDDevice, WebHIDDeviceFilter } from "./webHid.js";

export interface SpaceMouseVector3 {
    x: number;
    y: number;
    z: number;
}

export interface SpaceMouseDeviceState {
    translation: SpaceMouseVector3;
    rotation: SpaceMouseVector3;
    buttons: number;
}

export interface SpaceMouseHidSnapshot {
    reportId: number;
    data: DataView;
}

export const SPACEMOUSE_VENDOR_IDS = [0x046d, 0x256f];
export const SPACEMOUSE_TRANSLATION_REPORT_ID = 1;
export const SPACEMOUSE_ROTATION_REPORT_ID = 2;
export const SPACEMOUSE_BUTTON_REPORT_ID = 3;
export const SPACEMOUSE_OUTPUT_REPORT_ID = 4;

export function createSpaceMouseRequestFilters(): WebHIDDeviceFilter[] {
    return SPACEMOUSE_VENDOR_IDS.map(vendorId => ({ vendorId }));
}

export function createSpaceMouseDeviceState(): SpaceMouseDeviceState {
    return {
        translation: { x: 0, y: 0, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        buttons: 0,
    };
}

export function updateSpaceMouseDeviceState(state: SpaceMouseDeviceState, report: SpaceMouseHidSnapshot): SpaceMouseDeviceState {
    switch (report.reportId) {
        case SPACEMOUSE_TRANSLATION_REPORT_ID:
            readSpaceMouseVector(report.data, state.translation);
            break;
        case SPACEMOUSE_ROTATION_REPORT_ID:
            readSpaceMouseVector(report.data, state.rotation);
            break;
        case SPACEMOUSE_BUTTON_REPORT_ID:
            state.buttons = report.data.byteLength >= 1 ? report.data.getUint8(0) : 0;
            break;
    }
    return state;
}

export function isLikelySpaceMouseDevice(device: Pick<WebHIDDevice, "vendorId" | "productName">): boolean {
    const product = (device.productName ?? "").toLowerCase();
    if (product.includes("spacemouse") || product.includes("space mouse") || product.includes("spacepilot") || product.includes("space navigator")) {
        return true;
    }
    return SPACEMOUSE_VENDOR_IDS.includes(device.vendorId);
}

function readSpaceMouseVector(data: DataView, target: SpaceMouseVector3): void {
    if (data.byteLength < 6) return;
    target.x = data.getInt16(0, true);
    target.y = data.getInt16(2, true);
    target.z = data.getInt16(4, true);
}
